import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import EnergyUsage from './components/EnergyUsage';

const NoReimbursementStatement = ({statement}) => {
  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyUsage data={statement.data}/>
    </div>
  )
}

export default NoReimbursementStatement;

NoReimbursementStatement.propTypes = {
  statement: PropTypes.object.isRequired,
};